export default (name, size, type) => {
  const maxCvUploadSize = 600; //kilobyte
  const maxPicUploadSize = 300;
  let errors = [];

  if (name === "cv" && size > maxCvUploadSize) {
    errors.push("fileSize");
  }

  if (name === "pic" && size > maxPicUploadSize) {
    errors.push("fileSize");
  }

  if (name === "cv") {
    // accept only word and pdf
    if (!type.endsWith("document") && !type.endsWith("pdf")) {
      errors.push("fileType");
    }
  }

  if (name === "pic") {
    // accept only valid pic format
    if (
      !type.toLowerCase().endsWith("jpeg") &&
      !type.toLowerCase().endsWith("jpg") &&
      !type.toLowerCase().endsWith("png")
    ) {
      errors.push("fileType");
    }
  }

  return errors;
};



// WEBPACK FOOTER //
// ./src/utils/fileErrorCheck.js